// RIASEC interest questions as asked by the Dialogflow agent (AnnaChatbot export).
// The agent rotates through several wordings per question; `text` is the primary English one.
// A "Yes" adds one point to the question's `type` (each type has 7 questions, 0-7 points).
// `examples` / `examplesFil`: everyday situations shown under the question in the chat (added
// 2026-10-20, for the guidance office to review). They never hint which answer is better.
export const riasecQuestions = [
  {
    id: 1,
    type: 'realistic',
    text: 'Do you like to work on cars?',
    examples: ["Changing a flat tire or checking the oil", "Fixing a bike, motorcycle or tricycle", "Watching how a mechanic repairs an engine"],
    examplesFil: ["Pagpapalit ng flat na gulong o pag-check ng langis", "Pag-aayos ng bike, motor o tricycle", "Panonood kung paano inaayos ng mekaniko ang makina"],
  },
  {
    id: 2,
    type: 'investigative',
    text: 'Do you like to do puzzles?',
    examples: ["Solving crosswords, Sudoku or a Rubik's cube", "Figuring out riddles or logic games", "Finishing a jigsaw puzzle"],
    examplesFil: ["Pagsagot ng crossword, Sudoku o Rubik's cube", "Paglutas ng bugtong o logic games", "Pagbuo ng jigsaw puzzle"],
  },
  {
    id: 3,
    type: 'artistic',
    text: 'Are you good at working independently?',
    examples: ["Finishing a project without being reminded", "Planning your own way to do a task", "Working on your own ideas without a group"],
    examplesFil: ["Pagtatapos ng project kahit walang nagpapaalala", "Pagpaplano ng sariling paraan sa isang gawain", "Paggawa ng sariling ideya kahit walang grupo"],
  },
  {
    id: 4,
    type: 'social',
    text: 'Do you like to work in teams?',
    examples: ["Doing a group project with classmates", "Playing a team sport like basketball or volleyball", "Planning a class or barangay event together"],
    examplesFil: ["Paggawa ng group project kasama ang mga kaklase", "Paglalaro ng team sport gaya ng basketball o volleyball", "Sama-samang pagpaplano ng event sa klase o barangay"],
  },
  {
    id: 5,
    type: 'enterprising',
    text: 'Are you an ambitious person that sets goals for yourself?',
    examples: ["Aiming for a certain grade and working for it", "Saving up for something you want", "Planning what you'll do after senior high"],
    examplesFil: ["Pagtatakda ng gustong grado at pagsisikap para dito", "Pag-iipon para sa isang bagay na gusto mo", "Pagpaplano kung ano ang gagawin pagkatapos ng senior high"],
  },
  {
    id: 6,
    type: 'conventional',
    text: 'Do you like to organize things like files, papers etc?',
    examples: ["Sorting your notes and handouts by subject", "Keeping papers in labeled folders", "Arranging things on your desk or shelf neatly"],
    examplesFil: ["Pag-aayos ng notes at handouts ayon sa subject", "Paglalagay ng mga papel sa folder na may label", "Maayos na pag-aayos ng gamit sa mesa o estante"],
  },
  {
    id: 7,
    type: 'realistic',
    text: 'Do you like to build things?',
    examples: ["Making a shelf or stool from wood", "Building models for a school project", "Helping repair or build part of a house"],
    examplesFil: ["Paggawa ng estante o bangkito mula sa kahoy", "Paggawa ng model para sa school project", "Pagtulong sa pag-aayos o pagpapatayo ng bahay"],
  },
  {
    id: 8,
    type: 'artistic',
    text: 'Do you like to read about art and music?',
    examples: ["Reading about your favorite artists or bands", "Looking up how a song or painting was made", "Following pages about art, dance or film"],
    examplesFil: ["Pagbabasa tungkol sa paborito mong artist o banda", "Pag-alam kung paano ginawa ang isang kanta o painting", "Pag-follow ng pages tungkol sa sining, sayaw o pelikula"],
  },
  {
    id: 9,
    type: 'conventional',
    text: 'Do you like to have clear instructions to follow?',
    examples: ["Following a recipe step by step", "Asking for the rubric before starting a project", "Using a checklist so nothing gets missed"],
    examplesFil: ["Pagsunod sa recipe nang hakbang-hakbang", "Paghingi muna ng rubric bago simulan ang project", "Paggamit ng checklist para walang makaligtaan"],
  },
  {
    id: 10,
    type: 'enterprising',
    text: 'Do you like to try to influence or persuade people?',
    examples: ["Convincing friends to go with your plan", "Arguing for your side in a debate", "Campaigning for someone in a school election"],
    examplesFil: ["Pagkumbinsi sa mga kaibigan na sumama sa plano mo", "Pagtatanggol sa panig mo sa isang debate", "Pangangampanya para sa isang kandidato sa school election"],
  },
  {
    id: 11,
    type: 'investigative',
    text: 'Do you like doing experiments?',
    examples: ["Testing what happens when you mix things", "Doing hands-on activities in a science lab", "Trying different ways to see which works best"],
    examplesFil: ["Pagsubok kung ano ang mangyayari kapag pinaghalo ang mga bagay", "Paggawa ng hands-on activity sa science lab", "Pagsubok ng iba't ibang paraan para makita kung alin ang pinakamabisa"],
  },
  {
    id: 12,
    type: 'social',
    text: 'Do you like to teach or train people?',
    examples: ["Explaining a lesson to a classmate who is lost", "Teaching a younger sibling to read or count", "Showing someone new how things are done"],
    examplesFil: ["Pagpapaliwanag ng aralin sa kaklaseng nalilito", "Pagtuturo sa nakababatang kapatid na magbasa o magbilang", "Pagtuturo sa bagong kasama kung paano ginagawa ang mga bagay"],
  },
  {
    id: 13,
    type: 'social',
    text: 'Do you like to help people in solving their problems?',
    examples: ["Listening when a friend needs advice", "Helping friends patch up a misunderstanding", "Helping a classmate figure out what to do next"],
    examplesFil: ["Pakikinig kapag kailangan ng kaibigan ng payo", "Pagtulong ayusin ang tampuhan ng magkaibigan", "Pagtulong sa kaklase na alamin ang susunod na gagawin"],
  },
  {
    id: 14,
    type: 'realistic',
    text: 'Do you like to take care of animals?',
    examples: ["Feeding and bathing a pet dog or cat", "Raising chickens, pigs or other farm animals", "Helping a hurt or stray animal"],
    examplesFil: ["Pagpapakain at pagpapaligo sa alagang aso o pusa", "Pag-aalaga ng manok, baboy o iba pang hayop sa bukid", "Pagtulong sa sugatan o ligaw na hayop"],
  },
  {
    id: 15,
    type: 'conventional',
    text: 'Are you comfortable with a full day of learning in a classroom or library setting?',
    examples: ["Sitting through a full day of classes", "Studying for hours in the library", "Reading and taking notes for a long time"],
    examplesFil: ["Pag-upo sa buong araw ng klase", "Pag-aaral nang ilang oras sa library", "Matagal na pagbabasa at pagsusulat ng notes"],
  },
  {
    id: 16,
    type: 'enterprising',
    text: 'Do you like selling things?',
    examples: ["Selling snacks or baked goods at school", "Helping at a family sari-sari store", "Selling items online or at a school fair"],
    examplesFil: ["Pagbebenta ng meryenda o tinapay sa paaralan", "Pagtulong sa sari-sari store ng pamilya", "Pagbebenta online o sa school fair"],
  },
  {
    id: 17,
    type: 'artistic',
    text: 'Do you enjoy creative writing?',
    examples: ["Writing stories, poems or spoken word pieces", "Keeping a journal or blog", "Writing scripts for a class play or video"],
    examplesFil: ["Pagsusulat ng kuwento, tula o spoken word", "Pagsusulat sa journal o blog", "Pagsusulat ng script para sa dula o video ng klase"],
  },
  {
    id: 18,
    type: 'investigative',
    text: 'Do you enjoy science?',
    examples: ["Learning how the body, plants or animals work", "Watching videos about space or nature", "Wondering why things in nature happen"],
    examplesFil: ["Pag-alam kung paano gumagana ang katawan, halaman o hayop", "Panonood ng video tungkol sa kalawakan o kalikasan", "Pag-iisip kung bakit nangyayari ang mga bagay sa kalikasan"],
  },
  {
    id: 19,
    type: 'enterprising',
    text: 'Are you quick to take on new responsibilities?',
    examples: ["Volunteering to be group leader or class officer", "Saying yes when asked to handle a new task", "Taking charge when no one else steps up"],
    examplesFil: ["Pagboluntaryo bilang group leader o class officer", "Pagpayag agad kapag pinaasikaso ng bagong gawain", "Pag-ako ng responsibilidad kapag walang ibang kumikilos"],
  },
  {
    id: 20,
    type: 'social',
    text: 'Are you interested in healing people?',
    examples: ["Caring for a family member who is sick", "Learning first aid", "Thinking about work as a nurse, doctor or therapist"],
    examplesFil: ["Pag-aalaga sa kapamilyang may sakit", "Pag-aaral ng first aid", "Pag-iisip na maging nurse, doktor o therapist"],
  },
  {
    id: 21,
    type: 'investigative',
    text: 'Do you enjoy trying to figure out how things work?',
    examples: ["Opening a gadget to see what's inside", "Wondering how apps or machines work", "Looking up why something happens the way it does"],
    examplesFil: ["Pagbubukas ng gadget para makita ang loob", "Pag-iisip kung paano gumagana ang apps o makina", "Pag-search kung bakit nangyayari ang isang bagay"],
  },
  {
    id: 22,
    type: 'realistic',
    text: 'Do you like putting things together or assembling things?',
    examples: ["Assembling furniture by following a manual", "Building LEGO, model kits or robots", "Setting up a computer or electric fan"],
    examplesFil: ["Pag-assemble ng muwebles gamit ang manual", "Pagbuo ng LEGO, model kit o robot", "Pag-set up ng computer o electric fan"],
  },
  {
    id: 23,
    type: 'artistic',
    text: 'Are you a creative person?',
    examples: ["Coming up with new ideas for projects", "Decorating your room or notebook your own way", "Making things look or sound different from usual"],
    examplesFil: ["Pag-iisip ng bagong ideya para sa mga project", "Pagdedekorasyon ng kuwarto o notebook sa sariling paraan", "Paggawa ng bagay na kakaiba ang itsura o tunog"],
  },
  {
    id: 24,
    type: 'conventional',
    text: 'Do you pay attention to details?',
    examples: ["Noticing small mistakes in spelling or numbers", "Double-checking your work before passing it", "Remembering small things others forget"],
    examplesFil: ["Pagpansin sa maliliit na mali sa spelling o numero", "Pag-double check ng gawa bago ipasa", "Pag-alala sa maliliit na bagay na nakakalimutan ng iba"],
  },
  {
    id: 25,
    type: 'conventional',
    text: 'Do you like to do filing or typing?',
    examples: ["Typing up notes or reports neatly", "Encoding lists or data on a computer", "Filing papers so they're easy to find"],
    examplesFil: ["Maayos na pag-type ng notes o report", "Pag-encode ng listahan o data sa computer", "Pag-file ng mga papel para madaling mahanap"],
  },
  {
    id: 26,
    type: 'investigative',
    text: 'Do you like to analyze things?',
    examples: ["Looking for patterns in data or results", "Breaking a problem into smaller parts", "Comparing options before deciding"],
    examplesFil: ["Paghahanap ng pattern sa data o resulta", "Paghahati ng problema sa mas maliliit na bahagi", "Paghahambing ng mga pagpipilian bago magdesisyon"],
  },
  {
    id: 27,
    type: 'artistic',
    text: 'Do you like to play instruments or sing?',
    examples: ["Playing guitar, ukulele or piano", "Singing in a choir or at karaoke", "Joining a band or school music group"],
    examplesFil: ["Pagtugtog ng gitara, ukulele o piano", "Pagkanta sa choir o videoke", "Pagsali sa banda o music group sa paaralan"],
  },
  {
    id: 28,
    type: 'social',
    text: 'Do you enjoy learning about other cultures?',
    examples: ["Learning about food and traditions of other countries", "Getting to know classmates from other regions or cultural groups", "Picking up words from another language"],
    examplesFil: ["Pag-alam sa pagkain at tradisyon ng ibang bansa", "Pagkilala sa mga kaklase mula sa ibang rehiyon o pangkat-etniko", "Pag-aaral ng mga salita sa ibang wika"],
  },
  {
    id: 29,
    type: 'enterprising',
    text: 'Would you like to start your own business?',
    examples: ["Thinking of a product or service to sell", "Imagining running your own shop or brand", "Turning a hobby into a way to earn money"],
    examplesFil: ["Pag-iisip ng produkto o serbisyong ibebenta", "Pag-iisip na magpatakbo ng sariling tindahan o brand", "Paggawa ng pagkakakitaan mula sa hobby"],
  },
  {
    id: 30,
    type: 'realistic',
    text: 'Do you like to cook?',
    examples: ["Preparing meals for your family", "Trying a new recipe", "Baking or making snacks to share or sell"],
    examplesFil: ["Paghahanda ng pagkain para sa pamilya", "Pagsubok ng bagong recipe", "Pagbe-bake o paggawa ng meryenda para ibahagi o ibenta"],
  },
  {
    id: 31,
    type: 'artistic',
    text: 'Do you like acting in plays?',
    examples: ["Joining a school play or role play", "Acting in a video for a class project", "Performing in front of an audience"],
    examplesFil: ["Pagsali sa school play o role play", "Pag-arte sa video para sa class project", "Pagtatanghal sa harap ng maraming tao"],
  },
  {
    id: 32,
    type: 'realistic',
    text: 'Are you a practical person?',
    examples: ["Fixing things at home instead of replacing them", "Choosing the simplest way that works", "Learning by doing rather than only reading"],
    examplesFil: ["Pag-aayos ng sira sa bahay sa halip na palitan", "Pagpili ng pinakasimpleng paraan na gumagana", "Pag-aaral sa mismong paggawa kaysa sa pagbabasa lang"],
  },
  {
    id: 33,
    type: 'investigative',
    text: 'Do you like working with numbers or charts?',
    examples: ["Making graphs for a report or experiment", "Keeping track of scores or expenses", "Reading charts to understand what's going on"],
    examplesFil: ["Paggawa ng graph para sa report o experiment", "Pagtatala ng scores o gastos", "Pagbabasa ng chart para maintindihan ang nangyayari"],
  },
  {
    id: 34,
    type: 'social',
    text: 'Do you like to get into discussions about issues?',
    examples: ["Talking about news or community problems", "Sharing your views in a class discussion", "Listening to different sides of an issue"],
    examplesFil: ["Pag-uusap tungkol sa balita o problema sa komunidad", "Pagbabahagi ng pananaw sa talakayan sa klase", "Pakikinig sa iba't ibang panig ng isyu"],
  },
  {
    id: 35,
    type: 'conventional',
    text: 'Are you good at keeping records of your work?',
    examples: ["Listing what you've finished and what's left", "Saving copies of your outputs and grades", "Writing tasks and deadlines in a planner"],
    examplesFil: ["Paglilista ng mga natapos at natitirang gawain", "Pagtatago ng kopya ng outputs at grades", "Pagsusulat ng tasks at deadlines sa planner"],
  },
  {
    id: 36,
    type: 'enterprising',
    text: 'Do you like to lead?',
    examples: ["Leading a group project or club", "Running for class or school officer", "Deciding who does what in a team"],
    examplesFil: ["Pamumuno sa group project o club", "Pagtakbo bilang officer ng klase o paaralan", "Pagpapasya kung sino ang gagawa ng ano sa grupo"],
  },
  {
    id: 37,
    type: 'realistic',
    text: 'Do you like working outdoors?',
    examples: ["Gardening or farming", "Joining clean-ups or tree planting", "Hiking, camping or working out in the sun"],
    examplesFil: ["Paghahalaman o pagsasaka", "Pagsali sa clean-up drive o tree planting", "Pag-hike, pag-camping o pagtatrabaho sa labas"],
  },
  {
    id: 38,
    type: 'conventional',
    text: 'Do you like to work in an office?',
    examples: ["Working at a desk with a computer", "Answering calls and keeping schedules", "Helping out in the school or barangay office"],
    examplesFil: ["Pagtatrabaho sa mesa gamit ang computer", "Pagsagot ng tawag at pag-aayos ng schedule", "Pagtulong sa opisina ng paaralan o barangay"],
  },
  {
    id: 39,
    type: 'investigative',
    text: 'Are you good at Math?',
    examples: ["Solving equations or word problems", "Doing quick computations in your head", "Helping friends with math homework"],
    examplesFil: ["Paglutas ng equation o word problem", "Mabilis na pagkukuwenta sa isip", "Pagtulong sa kaibigan sa math assignment"],
  },
  {
    id: 40,
    type: 'social',
    text: 'Do you like helping people?',
    examples: ["Volunteering in outreach or community activities", "Running errands for an elderly neighbor", "Offering help when someone looks lost"],
    examplesFil: ["Pagboluntaryo sa outreach o gawain sa komunidad", "Pagtulong sa matandang kapitbahay sa mga lakad", "Pag-alok ng tulong kapag may mukhang nalilito"],
  },
  {
    id: 41,
    type: 'artistic',
    text: 'Do you like turning your ideas into pictures or designs?',
    examples: ["Drawing, painting or doodling", "Designing posters, shirts or logos", "Making layouts or edits on Canva or a phone app"],
    examplesFil: ["Pagguhit, pagpinta o pag-doodle", "Pagdidisenyo ng poster, t-shirt o logo", "Paggawa ng layout o edit sa Canva o phone app"],
  },
  {
    id: 42,
    type: 'enterprising',
    text: 'Do you like to give speeches?',
    examples: ["Speaking in front of the class", "Hosting a program or event", "Giving a talk to persuade or inspire people"],
    examplesFil: ["Pagsasalita sa harap ng klase", "Pag-host ng programa o event", "Pagbibigay ng talumpati para manghikayat o magbigay-inspirasyon"],
  },
];
